var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5486 14.016L16.5486 5.016L15.1426 3.563L7.5486 11.157L3.9856 7.594L2.5796 9L7.5486 14.016ZM16.5486 0C17.1113 0 17.5879 0.195333 17.9786 0.586C18.3693 0.976667 18.5646 1.45333 18.5646 2.016V15.985C18.5646 16.5477 18.3693 17.0243 17.9786 17.415C17.5879 17.8057 17.1113 18.001 16.5486 18.001H2.5796C2.01693 18.001 1.54027 17.8057 1.1496 17.415C0.758932 17.0243 0.563599 16.5477 0.563599 15.985V2.016C0.563599 1.45333 0.758932 0.976667 1.1496 0.586C1.54027 0.195333 2.01693 0 2.5796 0H16.5486Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkboxChecked.35df2b91.svg";
export { ForwardRef as ReactComponent };